module.exports = (parcelRequire.load("944Nh")).then(() => parcelRequire('ejby2'));